import React, { Component } from 'react';
import IconSet34 from 'components/Icon/IconSet34';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import IconAccount from '@material-ui/icons/AccountBox';
import { connect } from 'react-redux';


import {
  isLoggedIn,
  getCurrentUserRole,
} from 'ducks/authentication';

import IconSetMenu from 'components/Icon/IconSetMenu';

class HeaderLogin extends Component {
  render() {
    const { userRole } = this.props;
    return (
      <div className="HeaderLogin">
        <Link to={userRole !== 'admin' ? '/login' : '/logout'}>
        <Grid container spacing={0}
          direction="column"
          justify="center"
          alignItems="center"
          style={{height: '100%'}}
          >
          <Grid item xs style={{height: 34}}>
            <IconSet34 icon={'top'} size={34} style={{verticalAlign: 'top', width: '34px', height: 34}}/>
          </Grid>
          <Grid item xs>
{/*            <If condition={userRole === undefined}>
            <span>Votre espace</span>
          <span><IconAccount style={{width: 34, height: 34, display: 'inline-block', marginTop: 0, marginBottom: 0}}/></span>
            <span>personnel</span>
            </If>
            <If condition={userRole === 'candidat'}>
              <span>Votre</span>
              <IconSetMenu icon={'profile'} title={'Mon Profil'} url={'/profil'} className={'HeaderMenuIcon'} size={34} showTooltip={false} showLabel={false} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}}/>
                <span>Pofil</span>
              </If>
            <If condition={userRole === 'entreprise'}>
              <span>Vos</span>
              <IconSetMenu icon={'missions'} title={'Mon Profil'} url={'/profil'} className={'HeaderMenuIcon'} size={34} showTooltip={false} showLabel={false} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}}/>
                <span>Missions</span>
              </If>
*/}
            <If condition={userRole !== 'admin'}>
              <span>Votre espace</span>
            <span><IconAccount style={{width: 34, height: 34, display: 'inline-block', marginTop: 0, marginBottom: 0}}/></span>
              <span>personnel</span>
            </If>
            <If condition={userRole === 'admin'}>
              <span>Admin</span>
              <IconSetMenu icon={'logout'} title={'Logout'} url={'/logout'} className={'HeaderMenuIcon'} size={34} showTooltip={false} showLabel={false} buttonStyle={{backgroundColor: '#e24b4b', color: '#fff'}}/>
                <span>Deconnexion</span>
              </If>

          </Grid>
          <Grid item xs style={{height: 34}}>
            <IconSet34 icon={'bottom'} size={34} style={{verticalAlign: 'bottom', width: '34px', height: 34}}/>
          </Grid>
        </Grid>
        </Link>
      </div>
    );
  }
}

// export default HeaderLogin;
function mapStateToProps(state) {
  const props = {
    loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

// export default HeaderMenu;
export default connect(mapStateToProps)(HeaderLogin);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLogin.jsx